import { Component, Input, Output, EventEmitter, HostListener, ElementRef } from '@angular/core';

@Component({
  selector: 'app-dropdown-button',
  templateUrl: './dropdown-button.component.html',
  styleUrls: ['./dropdown-button.component.scss']
})
export class DropdownButtonComponent {

  @Input() label = '';
  @Input() isOpen = false;
  @Input() alignRight = false;
  @Input() icon = '';
  @Input() closeOnClick = true;
  @Output() valueChange = new EventEmitter<boolean>();
  @Input() color = '';
  @Input() floatOnMobile = false;
  @Input() public newHeight = false;
  @Input() public disabled = false;
  @Input() isRelative = true;
  @Input() id = 'dropdown-btn';

  @HostListener('document:click', ['$event'])
  onClick(ev) {
    if (this.isOpen && this.closeOnClick) {
      if (!this.eRef.nativeElement.contains(ev.target) && !ev.target.className.includes('calendar')) {
        this.isOpen = false;
        this.valueChange.emit(this.isOpen);
      }
    }
  }

  constructor(private eRef: ElementRef) { }

  changeValue() {
    this.isOpen = !this.isOpen;
    this.valueChange.emit(this.isOpen);
  }

}
